/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-useless-fragment */
import { useEffect } from "react";
import { BreadCrumb } from "ui/bread-crumbs";
import { PATHS } from "routes/paths";
import Loader from "ui/page-loader";
import { useLookupCashCenters, useLookupCustomers } from "services/lookups";
import ServiceCallsReports from "./service-calls";
import AllCallsReports from "./all-calls";

export default function Reports() {
  const {
    mutate: getCustomersList,
    data: customersListRes,
    isPending: gettingCustomersList,
  } = useLookupCustomers();
  const {
    mutate: getCashCenter,
    data: cashCenterListRes,
    isPending: gettingCashCenterList,
  } = useLookupCashCenters();

  useEffect(() => {
    getCustomersList();
    getCashCenter();
  }, []);

  return (
    <>
      {gettingCashCenterList || gettingCustomersList ? <Loader /> : <></>}

      <div className="form-container">
        <BreadCrumb
          items={[
            { to: PATHS.dashboard, text: `Dashboard` },
            {
              text: `Reports`,
            },
          ]}
        />

        <AllCallsReports
          customersList={customersListRes?.data || []}
          cashCentersList={cashCenterListRes?.data || []}
        />

        <ServiceCallsReports
          customersList={customersListRes?.data || []}
          cashCentersList={cashCenterListRes?.data || []}
        />
      </div>
    </>
  );
}
